var BASWebServices;
(function (BASWebServices) {
    'use strict';
    function runButton($compile) {
        return {
            restrict: "AE",
            transclude: true,
            link: function (scope, tElement, tAttrs, uploadElemenetCtrl) {
                scope.preview = tAttrs.preview;
                var divExtension = "";
                divExtension += '<div class="' + tAttrs.classestoset + ' row-element">';
                divExtension += '  <div class="runButtonFlexContainer">';
                divExtension += '    <div class="checkboxTOU">';
                divExtension += '      <input type="checkbox" ng-model="touRead" id="touReadCheckbox" >';
                divExtension += '      <label for="touReadCheckbox">I have read and accepted the <a data-ui-sref="help.tou" target="_blank">terms of usage</a> for this service, including the policy of monitoring access to the services (paragraph 5). I hereby confirm that I am a member of an academic institution or that I have obtained a BAS user license for this service. In case of a publication of my results I will use a proper citation to this service.';
                if (scope.optionaladditionalcheckboxmessage != "") {
                    divExtension += '<br/><span data-ng-bind-html="optionaladditionalcheckboxmessage | TrustedHtmlFilter"></span>';
                }
                divExtension += '      </label>';
                divExtension += '    </div>';
                divExtension += '    <div class="runButtonBox">';
                divExtension += '      <div class="button iconTextContainer" ';
                divExtension += '           ng-class="{disabled: !touRead}" ';
                divExtension += '          title="Click to execute the web service."';
                divExtension += '           data-ng-click="!ajaxQueueDone ? rbc.doNothing() : rbc.run()" >';
                divExtension += '        <span class="runButtonIcon"></span>';
                divExtension += '        <span class="iconText">Run Web Service</span>';
                divExtension += '      </div>';
                divExtension += '    </div>';
                divExtension += '  </div>';
                if (tAttrs.preview == "false") {
                    divExtension += '<h3 data-ng-show="RESULT && RESULT.length>0">Results ({{RESULT.length}})</h3>';
                    divExtension += '<div data-ng-show="RESULT && RESULT.length>0">';
                    divExtension += '  <div class="resultList">';
                    divExtension += '    <ul>';
                    divExtension += "      <li class='resultEntry' data-ng-repeat='resultEntry in RESULT track by $index' data-ng-controller='MultiplePreviewModalController'>";
                    divExtension += "        <a class='mpmcItem' data-ng-href='{{resultEntry}}' data-ng-click='$event.preventDefault(); mpmc.open(resultEntry)'>{{resultEntry|UrlFilter}}</a>";
                    divExtension += '      </li>';
                    divExtension += '    </ul>';
                    divExtension += '  </div>';
                    divExtension += '  <div class="button" ng-show="ajaxQueueDone && RESULT && RESULT.length>=1" data-ng-click="rbc.getZipFile()">';
                    if (tAttrs.secondstepbuttonlabel) {
                        divExtension +=
                            '    ' + tAttrs.secondstepbuttonlabel;
                    }
                    else {
                        divExtension +=
                            '    💾 Download as ZIP-File';
                    }
                    divExtension += '  </div>';
                    if (tAttrs.secondstepbuttonlabel) {
                        divExtension += '    <div data-ng-if="addressOfImageShownAfterSecondStep" data-ng-controller="MultiplePreviewModalController">';
                        divExtension += "        <a class='mpmcItem' data-ng-href='{{addressOfImageShownAfterSecondStep}}' data-ng-click='$event.preventDefault(); mpmc.open(addressOfImageShownAfterSecondStep)'>";
                        divExtension += '            <img src="{{addressOfImageShownAfterSecondStep}}" style="width: 100%; margin-top: 20px;">';
                        divExtension += '        </a>';
                        divExtension += '    </div>';
                    }
                    divExtension += '</div>';
                }
                else {
                    if (tAttrs.classestoset == undefined) {
                        tAttrs.classestoset = "";
                    }
                    divExtension += "<div file-previewer class='' ";
                    divExtension += "    classestoset='" + tAttrs.classestoset + "' ";
                    divExtension += "    fileLocation=uec.downloadLink ";
                    divExtension += "    resultvariabletowatch='RESULT_CONTENT' resultfilelink='RESULT[0]'>";
                    divExtension += "</div>";
                }
                divExtension += "</div>";
                tElement.append(divExtension);
                $compile(tElement.contents())(scope);
            }
        };
    }
    BASWebServices.runButton = runButton;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=runButton.js.map